import { render } from "./lottery.vue?vue&type=template&id=fc4795a8&scoped=true"
import script from "./lottery.vue?vue&type=script&setup=true&lang=js"
export * from "./lottery.vue?vue&type=script&setup=true&lang=js"

import "./lottery.vue?vue&type=style&index=0&id=fc4795a8&lang=scss&scoped=true"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4795a8"],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/lottery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc4795a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc4795a8', __exports__)) {
    console.log('reload')
    api.reload('fc4795a8', __exports__)
  }
  
  module.hot.accept("./lottery.vue?vue&type=template&id=fc4795a8&scoped=true", () => {
    console.log('re-render')
    api.rerender('fc4795a8', render)
  })

}


export default __exports__